<template>
    <div class="c-a-input" :class="{'c-a-input--invalid': invalid}">
        <label v-if="required" class="c-a-input__label" :for="`input-${name}-${id}`">{{label}}*</label>
        <label v-else class="c-a-input__label" :for="`input-${name}-${id}`">{{label}}</label>
        <div class="c-a-input__wrapper" :class="{'c-a-input__wrapper--with-icon-left': icon}">
            <icon
                v-if="icon"
                class="c-a-input__icon"
                :icon="icon"></icon>
            <input
                type="tel"
                class="c-a-input__input"
                :id="`input-${id}`"
                :value="value"
                @input="updated"
                :placeholder="placeholder"
            />
        </div>
    </div>
</template>

<script>
    import Icon from '../AtomIcon.vue';

    export default {
        components: {
            Icon
        },
        props:{
            id: Number,
            icon: String,
            label: String,
            name: String,
            placeholder: String,
            value: String,
            invalid: Boolean,
            required: Boolean
        },
        methods:{
            updated(event){
                this.$emit('input', event.target.value);
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/views/components/atoms/form/AtomInputPhone.vue